/**
 * Link único del Aviso de Privacidad, usado en el QR y textos de los PDFs
 * (Contrato, Contrato Proveedor). Cambiar aquí cuando se migre a
 * picparty.net/privacidad — un solo lugar para actualizarlo.
 */
export const AVISO_URL = "https://docs.google.com/document/d/1yblgW3E4PZmbnLWPxbAPmCB4xw-z1fQC0OymlUo9iFY/preview";
